import { render } from "./Bilan.vue?vue&type=template&id=2d579633"
import script from "./Bilan.vue?vue&type=script&lang=js"
export * from "./Bilan.vue?vue&type=script&lang=js"

import "./Bilan.vue?vue&type=style&index=0&id=2d579633&lang=less"
script.render = render

export default script